// external imports
import React from 'react'
import { FlexRow, FlexColumn, Input, Form, PrimaryButton, GetTheme, Select, Option } from 'quark-web'
import { NavLink, Link as NativeLink, withRouter } from 'react-router-dom'
// local imports
import styles from './styles'
import { Logo, Text, SearchInput } from '~/components'
import LocaleSelect from './LocaleSelect'
import './responsive.css' // responsive layout styling only
import menu from './images/menu_yellow.png'

const Link = ({ children, ...props }) => (
    <Text style={{ marginBottom: 0 }}>
        <NavLink className='navLink' {...props} style={styles.link} activeStyle={styles.linkActive}>
            {children}
        </NavLink>
    </Text>
)

const Nav = ({ history }) => (
    <GetTheme>
        {({ grey5 }) => (
            <Form
                validate={{
                    search: val => (val && val.length > 0 ? null : 'required')
                }}
            >
                {({ getValue, setValue, hasErrors }) => (
                    <FlexRow
                        alignSelf="center"
                        alignItems="flex-end"
                        justifyContent="space-between"
                        style={styles.container}
                    >
                        <NativeLink to="/">
                            <Logo />
                        </NativeLink>
                        <FlexColumn
                            grow={1}
                            justifyContent="space-between"
                            alignItems="flex-end"
                            style={styles.navContainer}
                        >
                            {/* <FlexRow>
                                <LocaleSelect style={styles.localeSelect} />
                                <SearchInput
                                    onSubmit={({ value, clear }) => {
                                        // move the browser to the search page
                                        history.push(`/search?query=${value}`)
                                        // clear the search
                                        clear()
                                    }}
                                />
                            </FlexRow> */}
                            <FlexRow justifyContent="flex-end">
                                <Link exact to="/"> home </Link>
                                <Link to="/company">company</Link>
                                <Link to="/research">research</Link>
                                <Link to="/products">products</Link>
                                <Link to="/distributors">distributors</Link>
                                <Link to="/contact">contact</Link>
                            </FlexRow>
                        </FlexColumn>
                    </FlexRow>
                )}
            </Form>
        )}
    </GetTheme>
)

const Offline = ({ history }) => (
    <GetTheme>
        {({ grey5 }) => (
            <Form
                validate={{
                    search: val => (val && val.length > 0 ? null : 'required')
                }}
            >
                {({ getValue, setValue, hasErrors }) => (
                    <FlexRow
                        alignSelf="center"
                        alignItems="flex-end"
                        justifyContent="space-between"
                        style={styles.container}
                    >
                        <NativeLink to="/">
                            <Logo />
                        </NativeLink>
                        <FlexColumn
                            grow={1}
                            justifyContent="space-between"
                            alignItems="flex-end"
                            style={styles.navContainer}
                        >
                            <FlexRow>
                                <LocaleSelect style={styles.localeSelect} />
                                <SearchInput
                                    onSubmit={({ value, clear }) => {
                                        // move the browser to the search page
                                        history.push(`/search?query=${value}`)
                                        // clear the search
                                        clear()
                                    }}
                                />
                            </FlexRow>
                            <FlexRow justifyContent="flex-end">
                                <Link exact to="/">
                                    home
                                </Link>
                            </FlexRow>
                        </FlexColumn>
                    </FlexRow>
                )}
            </Form>
        )}
    </GetTheme>
)

var active = false;

const collapse = () => {
    active = !active;
    var navLinks = document.getElementsByClassName('nav')[0].classList;
    if (active){
        navLinks.add("navActive")
    } 
    else {
        navLinks.remove("navActive")
    }
}

const responsive = ({ history }) => (
    <div className='container'>
        <FlexRow
         className='logoButtonRow'
         justifyContent="space-between"
         alignItems="center">
            <NativeLink to="/">
                <Logo />
            </NativeLink>
            <a onClick={collapse}>
                <img className='menu' src={menu} height={60} style={{ margin: 15, alignSelf: 'center' }}/> 
            </a> 
        </FlexRow>
        <div 
        className='nav'
        style={styles.navRow}>
            <Link onClick={collapse} exact to="/">Home</Link>
            <Link onClick={collapse} to="/company">company</Link>
            <Link onClick={collapse} to="/research">research</Link>
            <Link onClick={collapse} to="/products">products</Link>
            {/* <Link to="/distributors">distributors</Link> */}
            <Link onClick={collapse} to="/contact">contact</Link>
        </div>
    </div>

)

const kellyNav = ({ history }) => (
    <FlexColumn
    alignItems="center">
        <FlexRow>
            <NativeLink to="/">
                <Logo />
            </NativeLink>
            <img className='menu' src={menu} height={70} style={{ margin: 15, alignSelf: 'center' }}/>  
        </FlexRow>
        <FlexRow
        style={styles.navRow}>
            <Link exact to="/">Home</Link>
            <Link to="/company">company</Link>
            <Link to="/research">research</Link>
            <Link to="/products">products</Link>
            {/* <Link to="/distributors">distributors</Link> */}
            <Link to="/contact">contact</Link>
        </FlexRow>
    </FlexColumn>

)

export default withRouter(responsive)



// WEBPACK FOOTER //
// ./src/views/Root/Nav/index.js